import { toast } from "@UI/components/Molecules/Notification/toast.ts";

import VersionToastInfo from "./VersionToastInfo";

/**
 * Tells the user a newer build is available and offers a reload.
 *
 * Fired from three places — the periodic version poll, Vite's preload failure
 * (a chunk that no longer exists on the server) and the lazy-chunk error
 * boundary. The stable `update` id means concurrent triggers collapse into one
 * toast rather than stacking.
 */
export const showAppOutdatedToast = () =>
  toast(<VersionToastInfo />, {
    id: "update",
    duration: false,
    position: "top-center",
    plain: true,
    dismissible: true,
  });
